import React, { createContext, useContext, useState } from "react";

const PlaceContext = createContext(null);
export const usePlaceContext = () => useContext(PlaceContext);

export function PlaceContextProvider({ children }) {
  const [current, setCurrent] = useState(null); // { geo_id, name }
  return <PlaceContext.Provider value={{ current, setCurrent }}>{children}</PlaceContext.Provider>;
}
